import { Fragment } from "react";
import { Typography } from "@mui/material";
import { OverflowText } from "@verity/components/core";
import { MatchingAnswer, MatchingPairInstructor } from "@verity/api-client/types";
import CorrectIcon from "../../../../../images/quiz-question/option-correct-answer-checked-icon.svg?react";
import InCorrectIcon from "../../../../../images/quiz-question/option-inccorect-icon.svg?react";
import pageStyles from "../QuizResultPanel.module.css";
import styles from "./QuestionAnswer.module.css";
import { AnswerViewProps, CorrectAnswerViewProps, t } from "./shared";

export function MatchingAnswerView({ question, response }: AnswerViewProps) {
	const pairs = (question.options as MatchingPairInstructor[] | undefined) ?? [];
	const filteredPairs = pairs.filter((o): o is Extract<MatchingPairInstructor, { premise: string }> => "premise" in o);
	const userAnswers: MatchingAnswer = (response?.answer as MatchingAnswer) ?? {};

	return (
		<div className={styles.matchingPairGridyLayout}>
			{filteredPairs.map((pair, idx) => {
				const userResponse = userAnswers[pair.premise] ?? "";
				const isUnanswered = !userResponse;
				const isCorrect = !isUnanswered && userResponse === pair.response;
				const responseClass = `${styles.option} ${!isUnanswered && isCorrect ? styles.correct : ""} ${!isUnanswered && !isCorrect ? styles.incorrect : ""}`;
				const indexClass = `${styles.optionIndexBox} ${!isUnanswered && isCorrect ? styles.correct : ""} ${!isUnanswered && !isCorrect ? styles.incorrect : ""}`;
				return (
					<Fragment key={idx}>
						<div className={styles.option}>
							<div className={styles.optionIndexBox}>{idx + 1}</div>
							<OverflowText
								variant="body2"
								fontWeight={400}
								fontSize="14px"
								style={{
									flexGrow: 1,
									minWidth: 0,
								}}
							>
								{pair.premise}
							</OverflowText>
						</div>
						<div className={responseClass}>
							<div className={indexClass}>
								{!isUnanswered && isCorrect && <CorrectIcon />}
								{!isUnanswered && !isCorrect && <InCorrectIcon />}
							</div>
							<OverflowText
								variant="body2"
								fontWeight={400}
								fontSize="14px"
								style={{
									flexGrow: 1,
									minWidth: 0,
								}}
							>
								{userResponse || t("unanswered")}
							</OverflowText>
						</div>
					</Fragment>
				);
			})}
		</div>
	);
}

export function MatchingCorrectAnswer({ question }: CorrectAnswerViewProps) {
	const pairs = (question.options as MatchingPairInstructor[] | undefined) ?? [];
	if (pairs.length === 0) return null;
	const filteredPairs = pairs.filter((o): o is Extract<MatchingPairInstructor, { premise: string }> => "premise" in o);

	return (
		<div className={styles.correctAnswerSection}>
			<Typography className={pageStyles.sectionLabel}>{t("correctAnswer")}</Typography>
			<div className={styles.correctAnswerList}>
				{filteredPairs.map((pair, idx) => (
					<Typography key={idx} className={styles.correctAnswerItem}>
						{pair.premise} → {pair.response}
					</Typography>
				))}
			</div>
		</div>
	);
}
